const state = {
  progress: { current: 0, max: 0 },
  is_sync_error: false,
};

const mutations = {
  clearProgress(state) {
    state.progress.current = 0;
    state.progress.max = 0;
  },
  setProgressMax(state, data) {
    state.progress.max = data;
  },
  setProgressCurrent(state, data) {
    state.progress.current = data;
  },
  sync_error(state, data) {
    state.is_sync_error = data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
